import { RootState } from '@global/store/store';

export const useOldBillingInfoSelector = (state: RootState) =>
  state.subscriptionPayment.useOldBillingInfo;
